<template>
  <div
    class="search-box"
    :class="{ 'container--mobile': isMobile, 'container--desktop': !isMobile }"
  >
    <BIconSearch
      class="icon"
      :class="{ 'icon--mobile': isMobile, 'icon--desktop': !isMobile }"
    />
    <Input
      :placeholder="placeholder"
      :value="value"
      :class="{ 'input--mobile': isMobile, 'input--desktop': !isMobile }"
      @input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<script>
import { BIconSearch } from "bootstrap-vue";
export default {
  name: "search-bar",
  components: { BIconSearch },
  props: {
    placeholder: String,
    value: String,
    isMobile: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.search-box {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.container--mobile {
  background-color: $gyra-grey-dark;
}

.container--desktop {
}

.icon {
  margin-right: 14.6px;
  font-weight: 900;
}

.icon--mobile {
  color: white;
  margin-left: 25px;
}

.icon--desktop {
  color: $gyra-grey-dark;
}
input {
  outline: none;
  border: none;
  height: 100%;
  color: $gyra-grey-dark;
}

.input--mobile {
  background-color: $gyra-grey-dark;
  color: white;
}

.input--desktop {
}
</style>
